import '../appMain';

import * as React from 'react';
import * as ReactDOM from "react-dom";

import {ShiftShift} from "./components/shift_shift/shift_shift";
import type {ShiftShiftProps} from "./components/shift_shift/shift_shift";
import {MoveTo} from "./components/move_to/move_to";
import type {MoveToProps} from "./components/move_to/move_to";

import {BookmarkSelector} from "./components/bookmark_selector/bookmark_selector";
import type {BookmarkSelectorProps} from "./components/bookmark_selector/bookmark_selector";
import {createBookmarksModel} from "./components/shift_shift/bookmarks/bookmarks_model";

import {SlackWorkspacesTable} from "./components/slack/slack_workspaces_table";

// It is TS-based, so import here
import "./list_item_searcher"

const MaxkirReactUI = {

    renderShiftShift: (target: Element, props: ShiftShiftProps): () => void => {
        ReactDOM.render(
            <ShiftShift {...props} />,
            target,
        );
        return () => { ReactDOM.unmountComponentAtNode(target) }
    },

    renderMoveTo: (target: Element, props: MoveToProps): () => void => {
        ReactDOM.render(
            <MoveTo {...props} />,
            target,
        );
        return () => { ReactDOM.unmountComponentAtNode(target) }
    },

    renderBookmarkSelector: (target: Element, props: BookmarkSelectorProps): () => void => {
        ReactDOM.render(
            <BookmarkSelector {...props} />,
            target,
        );
        return () => { ReactDOM.unmountComponentAtNode(target) }
    },

    renderSlackWorkspaces: (target: Element): () => void => {
        ReactDOM.render(
            <SlackWorkspacesTable />,
            target,
        );
        return () => {
            ReactDOM.unmountComponentAtNode(target)
        }
    }
}

// @ts-ignore
maxkir.ReactUI = MaxkirReactUI;

// Test-only exports
// @ts-ignore
maxkir.TestHelpers = { createBookmarksModel };